module.exports = __webpack_public_path__ + "img/zhgjn_icon_jqpt_2.png";